import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { errorToast, successToast } from "../Common/showtoast";
import ApiRequest, { baseurl } from "../Common/restservice";
import ImageWithFallback from "../Components/ImageWithFallback";
import banner from "../Assets/Images/homebanner.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { Rating } from "react-simple-star-rating";
import { BiBriefcase, BiBullseye, BiCalendar } from "react-icons/bi";
import { FaLocationPin, FaServicestack } from "react-icons/fa6";
import { BsEye, BsStar } from "react-icons/bs";
import { TiDocument, TiNotes } from "react-icons/ti";
import {
  FaCalendar,
  FaCalendarWeek,
  FaClock,
  FaGraduationCap,
  FaMapMarker,
  FaRegCalendar,
  FaStar,
} from "react-icons/fa";
import moment from "moment";
import { TbPhotoScan } from "react-icons/tb";
import Slider from "react-slick";
const reportcomments = [
  "Illegal/fraudulent",
  "Spam",
  "Duplicate User",
  "Against company rules",
  "Others",
];
function IndividualDetail() {
  const carouselsettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };



  const navigate = useNavigate();
  const { memberid } = useParams();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(1);
  const [freeLancers, setfreeLancers] = useState({});
  const [contactDetails, setcontactDetails] = useState({});
  const [showContact, setshowContact] = useState(false);
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState("");
  const [reportMessage, setReportMessage] = useState("");
  const [selectedReport, setSelectedReport] = useState("");
  const [comments, setComments] = useState([]);
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    } else {
      GetFreeLancers();
      GetPhotos();
      GetComments();
    }
  }, [memberid]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const GetPhotos = async () => {
    let res = await ApiRequest(
      "getPortfolioImages.asp",
      "POST",
      JSON.stringify({ memberid: memberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      setPhotos([]);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setPhotos(res.items);
  };
  const GetFreeLancers = async () => {
    let res = await ApiRequest(
      "profiledetail.asp",
      "POST",
      JSON.stringify({ profileid: memberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      } else if (
        res.message === "Please update your profile to access other profiles,"
      ) {
        return navigate("/profile?err=" + res.message);
      }
      errorToast(res.message);
      return;
    }
    setfreeLancers(res);
  };
  const GetComments = async () => {
    let res = await ApiRequest(
      "getcomments.asp",
      "POST",
      JSON.stringify({ pageno: 1, memberid: memberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      setComments([]);
      return;
    }
    setComments(res.items);
  };
  const AddComments = async () => {
    if (!rating) {
      return errorToast("Select valid rating");
    }
    let res = await ApiRequest(
      "add_comments.asp",
      "POST",
      JSON.stringify({ commentfor: memberid, rating, message: comment }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    setRating(0);
    setComment("");
    GetComments();
    GetFreeLancers();
  };
  const ReportUser = async () => {
    if (!selectedReport) {
      return errorToast("Please select the issue");
    } else if (selectedReport === "Others" && !reportMessage) {
      return errorToast("Enter valid message");
    }
    let res = await ApiRequest(
      "report_user.asp",
      "POST",
      JSON.stringify({
        commentfor: memberid,
        message: selectedReport === "Others" ? reportMessage : selectedReport,
      }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    setSelectedReport("");
    setReportMessage("");
  };
  const GetContacts = async () => {
    let res = await ApiRequest(
      "getContact.asp",
      "POST",
      JSON.stringify({
        profileid: memberid,
      }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    setcontactDetails(res);
    setshowContact(true);
  };
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Individual</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Individual
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb" data-select2-id="13">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">User Info</h3>
                </div>
                <div class="card-body  item-user">
                  <div class="profile-pic mb-0">
                    <ImageWithFallback
                      class="brround avatar-xxl"
                      src={baseurl + freeLancers.profilepic}
                      alt="admin"
                    />
                    <div class="">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        class="text-dark"
                      >
                        <h4 class="mt-3 mb-1 font-weight-semibold">
                          {freeLancers.fullname}
                        </h4>
                      </a>
                      <span class="text-muted">
                        Member Since {freeLancers.joiningdate}
                      </span>
                    </div>
                  </div>
                </div>
                <aside class="app-sidebar doc-sidebar my-dash open">
                  <div class="app-sidebar__user clearfix is-expanded">
                    <ul class="side-menu open">
                      <li>
                        <label
                          onClick={() => setCurrentTab(1)}
                          className={`side-menu__item mb-0 ${currentTab === 1 ? "active" : ""
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          <TiDocument className="side-menu__icon" />
                          <span className="side-menu__label">Description</span>
                        </label>
                      </li>
                      <li>
                        <label
                          onClick={() => setCurrentTab(3)}
                          className={`side-menu__item mb-0 ${currentTab === 3 ? "active" : ""
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          <FaGraduationCap className="side-menu__icon" />
                          <span className="side-menu__label">About</span>
                        </label>
                      </li>
                      <li>
                        <label
                          onClick={() => setCurrentTab(4)}
                          className={`side-menu__item mb-0 ${currentTab === 4 ? "active" : ""
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          <BiBriefcase className="side-menu__icon" />
                          <span className="side-menu__label">
                            Professional Details
                          </span>
                        </label>
                      </li>

                      <li>
                        <label
                          onClick={() => setCurrentTab(6)}
                          className={`side-menu__item mb-0 ${currentTab === 6 ? "active" : ""
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          <FaServicestack className="side-menu__icon" />
                          <span className="side-menu__label">
                            Specialization / Expertise & Product / Service
                          </span>
                        </label>
                      </li>
                      <li>
                        <label
                          onClick={() => setCurrentTab(5)}
                          className={`side-menu__item mb-0 ${currentTab === 5 ? "active" : ""
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          <TbPhotoScan className="side-menu__icon" />
                          <span className="side-menu__label">Gallery</span>
                        </label>
                      </li>
                      <li>
                        <label
                          onClick={() => setCurrentTab(2)}
                          className={`side-menu__item mb-0 ${currentTab === 2 ? "active" : ""
                            }`}
                          style={{ cursor: "pointer" }}
                        >
                          <BsStar className="side-menu__icon" />
                          <span className="side-menu__label">Reviews</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </aside>
                {showContact && (
                  <div class="card-body item-user">
                    <h4 class="mb-4">Contact Info</h4>
                    <div>
                      <h6>
                        <span class="font-weight-semibold">
                          <i class="fa fa-envelope me-2 mb-2"></i>
                        </span>
                        <a
                          href={`mailto:${contactDetails.email}`}
                          class="text-body"
                        >
                          {contactDetails.email}
                        </a>
                      </h6>
                      <h6>
                        <span class="font-weight-semibold">
                          <i class="fa fa-phone me-2  mb-2"></i>
                        </span>
                        <a
                          href={`tel:${contactDetails.mobile}`}
                          class="text-primary"
                        >
                          {contactDetails.mobile}
                        </a>
                      </h6>
                      <h6>
                        <span class="font-weight-semibold">
                          <i class="fa fa-phone me-2  mb-2"></i>
                        </span>
                        <a
                          href={`tel:${freeLancers.alternatemobile}`}
                          class="text-primary"
                        >
                          {freeLancers.alternatemobile}
                        </a>
                      </h6>
                      {freeLancers.website && <h6>
                        <span class="font-weight-semibold">
                          <i class="fa fa-link me-2 "></i>
                        </span>
                        <a
                          href={freeLancers.website?.startsWith("http")
                            ? freeLancers.website
                            : `https://${freeLancers.website}`}
                          target="_blank"
                          class="text-primary"
                        >
                          {freeLancers.website}
                        </a>
                      </h6>}
                    </div>
                    <div class=" item-user-icons mt-4">
                      {freeLancers.facebookprofile && <a
                        href={freeLancers.facebookprofile?.startsWith("http")
                          ? freeLancers.facebookprofile
                          : `https://${freeLancers.facebookprofile}`}
                        target="_blank"
                        class="facebook-bg mt-0"
                      >
                        <i class="fa fa-facebook"></i>
                      </a>}
                      {(freeLancers.instagramprofile ||
                        freeLancers.instaprofile) && <a
                          href={
                            freeLancers.instagramprofile ||
                            freeLancers.instaprofile
                          }
                          target="_blank"
                          class="bg-pink  text-white"
                        >
                          <i class="fa fa-instagram"></i>
                        </a>}
                      {freeLancers.linkedinprofile && <a
                        href={freeLancers.linkedinprofile?.startsWith("http")
                          ? freeLancers.linkedinprofile
                          : `https://${freeLancers.linkedinprofile}`}
                        target="_blank"
                        class="bg-info text-white"
                      >
                        <i class="fa fa-linkedin"></i>
                      </a>}
                    </div>
                  </div>
                )}
                <div class="card-footer">
                  <div class="text-start">
                    <button
                      class="btn btn-primary"
                      onClick={() => {
                        if (!showContact) GetContacts();
                        else setshowContact(false);
                      }}
                    >
                      <i class="fa fa-user"></i> Contact Me
                    </button>
                  </div>
                </div>
              </div>
              {/* <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Report User</h3>
                </div>
                <div class="card-body product-filter-desc">
                  <div class="product-tags clearfix">
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        ReportUser();
                      }}
                      class="form-horizontal"
                    >
                      <div class="radio">
                        {reportcomments.map((item) => {
                          return (
                            <div className="form-group" key={item}>
                              <input
                                id={item}
                                value={item}
                                type="radio"
                                name="report_ad_val"
                                checked={selectedReport === item}
                                onChange={(e) =>
                                  setSelectedReport(e.target.value)
                                }
                              />
                              <label htmlFor={item}> &nbsp; &nbsp;{item}</label>
                            </div>
                          );
                        })}
                      </div>
                      {selectedReport === "Others" && (
                        <textarea
                          id="other_report"
                          name="other_report"
                          class="form-control"
                          placeholder="Type here..!"
                          value={reportMessage}
                          style={{ margin: 0, marginBottom: 10 }}
                          onChange={(e) => setReportMessage(e.target.value)}
                        ></textarea>
                      )}
                      <button
                        class="btn btn-primary"
                        name="report_ad"
                        value="report_ad"
                        type="submit"
                      >
                        Report
                      </button>
                    </form>
                  </div>
                </div>
              </div> */}
              {window.innerWidth > 720 && (
                <>
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Leave a Comment</h3>
                    </div>
                    <div class="card-body product-filter-desc">
                      <div class="product-tags clearfix">
                        <form
                          class="form"
                          name="contactForm"
                          onSubmit={(e) => {
                            e.preventDefault();
                            AddComments();
                          }}
                        >
                          <p>
                            Your email address will not be published. Required
                            fields are marked.{" "}
                            <span class="text-danger">*</span>
                          </p>
                          <div class="form-group">
                            <label class="text-start" htmlFor="msg">
                              Rating :<span style={{ color: "red" }}>*</span>
                            </label>
                            <Rating
                              style={{ marginLeft: "10px" }}
                              initialValue={rating}
                              onClick={(number) => setRating(number)}
                            />
                            <label
                              class="text-start mt-5"
                              htmlFor="msg"
                              style={{ width: "100%" }}
                            >
                              Comment :<span style={{ color: "red" }}></span>
                              <small
                                style={{ float: "right", marginLeft: "auto" }}
                              >
                                {comment?.length || 0} / 500
                              </small>
                            </label>
                            <textarea
                              id="msg"
                              style={{ minHeight: 100, margin: 0 }}
                              name="comments"
                              class="form-control"
                              onChange={(e) => {
                                if (e.target.value.length <= 500)
                                  setComment(e.target.value);
                              }}
                              value={comment}
                              placeholder="Type Message"
                            ></textarea>
                          </div>
                          <button class="btn btn-primary" type="submit">
                            Post Comment
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Shares</h3>
                    </div>
                    <div class="card-body product-filter-desc">
                      <div class="product-filter-icons text-center">
                        <WhatsappShareButton
                          className=" apss-single-icon"
                          url={window.location.href}
                        >
                          <WhatsappIcon size={32} className="facebook-bg" />
                        </WhatsappShareButton>
                        <FacebookShareButton
                          className=" apss-single-icon"
                          url={window.location.href}
                        >
                          <FacebookIcon size={32} className="facebook-bg" />
                        </FacebookShareButton>
                        <TwitterShareButton
                          className=" apss-single-icon"
                          url={window.location.href}
                        >
                          <TwitterIcon size={32} className="apss-icon-block" />
                        </TwitterShareButton>
                        <PinterestShareButton
                          className=" apss-single-icon"
                          url={window.location.href}
                          media={window.location.href}
                        >
                          <PinterestIcon
                            size={32}
                            className="apss-icon-block"
                          />
                        </PinterestShareButton>
                        <LinkedinShareButton
                          className=" apss-single-icon"
                          url={window.location.href}
                        >
                          <LinkedinIcon size={32} className="apss-icon-block" />
                        </LinkedinShareButton>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div class="col-xl-8 col-lg-8 col-md-12">
              <div class="card overflow-hidden">
                <div class="card-body h-100 boot-slider">
                  <div class="item-det mb-1">
                    <a href="#" class="text-dark">
                      <h3 class="">{freeLancers.fullname}</h3>
                    </a>
                    <ul class="d-flex">
                      <li class="me-5">
                        <label class="icons">
                          <BiBriefcase className=" text-muted me-1" />
                          {freeLancers.industry}
                        </label>
                      </li>
                      <li class="me-5">
                        <label class="icons">
                          <FaLocationPin className=" text-muted me-1" />
                          {freeLancers.city}
                        </label>
                      </li>
                      <li class="me-5">
                        <label class="icons">
                          <BiCalendar className=" text-muted me-1" />
                          {freeLancers.joiningdate}
                        </label>
                      </li>
                      <li class="me-5">
                        <label class="icons">
                          <BsEye className=" text-muted me-1" />
                          {freeLancers.number_of_review}
                        </label>
                      </li>
                      <li class="">
                        <label class="icons">
                          {[1, 2, 3, 4, 5].map((item) => {
                            return freeLancers.avg_star_rating &&
                              parseInt(freeLancers.avg_star_rating) >= item ? (
                              <i key={item} class="fa fa-star text-warning"></i>
                            ) : (
                              <i key={item} class="fa fa-star text-muted"></i>
                            );
                            //  <i class="fa fa-star text-warning"></i> <i class="fa fa-star text-warning"></i> <i class="fa fa-star text-warning"></i> <i class="fa fa-star-half-o text-warning me-1"></i>
                          })}
                          <span className=" ms-1">
                            {freeLancers.avg_star_rating || 0}
                          </span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  {/* "slider will be placed" */}
                </div>
              </div>
              {currentTab === 1 && (
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">Description</h3>
                  </div>
                  <div class="card-body">
                    <div class="mb-4">
                      <p>{freeLancers.description}</p>
                    </div>
                    <h4 class="mb-4">Specifications</h4>
                    <div class="row">
                      <div class="col-xl-6 col-md-12">
                        <ul class="list-unstyled widget-spec mb-0">
                          <li class="">
                            <i class="fa fa-user text-muted w-5"></i>
                            {freeLancers.fullname}
                          </li>
                          <li class="">
                            <i class="fa fa-calendar text-muted w-5"></i>
                            Member Since : {freeLancers.joiningdate}
                          </li>
                          <li class="">
                            <i class="fa fa-briefcase text-muted w-5"></i>
                            Working Hours: {freeLancers.availabletime}
                          </li>
                          <li class="">
                            <i class="fa fa-calendar-o text-muted w-5"></i>
                            {/* <FaRegCalendar className=" text-muted w-5" /> */}
                            Responds Within : {freeLancers.responsetime}
                          </li>
                          <li class="">
                            <i class="fa fa-clock-o text-muted w-5"></i>
                            {/* <FaClock className=" text-muted w-5"/> */}
                            Contact Time : {freeLancers.contacttime}
                          </li>
                          <li class="">
                            <i class="fa fa-phone text-muted w-5"></i>
                            {/* <FaClock className=" text-muted w-5"/> */}
                            Pref. Communication Method :{" "}
                            {freeLancers.preferredcontact}
                          </li>
                        </ul>
                      </div>
                      <div class="col-xl-6 col-md-12">
                        <ul class="list-unstyled widget-spec mb-0">
                          <li class="">
                            <i class="fa fa-map-signs text-muted w-5"></i>
                            City : {freeLancers.city}
                          </li>
                          <li class="">
                            <i class="fa fa-map text-muted w-5"></i>
                            {/* <FaGraduationCap className=" text-muted w-5"/> */}
                            Region : {freeLancers.region}
                          </li>
                          <li class="">
                            <i class="fa fa-flag text-muted w-5"></i>
                            {/* <FaGraduationCap className=" text-muted w-5"/> */}
                            Country : {freeLancers.country}
                          </li>
                          <li class="">
                            <i class="fa fa-map-pin text-muted w-5"></i>
                            {/* <FaGraduationCap className=" text-muted w-5"/> */}
                            Pincode : {freeLancers.pincode}
                          </li>
                          <li class="">
                            <i class="fa fa-money text-muted w-5"></i> Pricing
                            Accepted :{freeLancers.pricing}
                          </li>
                          {/* <li class="">
                            <i class="fa fa-calendar-check-o text-muted w-5"></i>
                            Passed : {freeLancers.passedyear}
                          </li>
                          <li class="">
                            <i class="fa fa-percent text-muted w-5"></i> CGPA :
                            {freeLancers.cgpa}
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentTab === 3 && (
                <div class="card">
                  <div class="card-body">
                    <h4 class="mb-4">Relevant Certifications</h4>
                    <div class="mb-4">
                      <p>
                        {freeLancers.certifications || "-- Not Disclosed --"}
                      </p>
                    </div>
                    <hr />
                    <h4 class="mb-4">Ongoing Learnings</h4>
                    <div class="mb-4">
                      <p>{freeLancers.learnings || "-- Not Disclosed --"}</p>
                    </div>
                    <hr />
                    <h4 class="mb-4">Specifications</h4>
                    <div class="row">
                      <div class="col-xl-6 col-md-12">
                        <ul class="list-unstyled widget-spec mb-0">
                          <li class="">
                            <i class="fa fa-graduation-cap text-muted w-5"></i>
                            Requirement / Service : {freeLancers.highestdegree}
                          </li>
                          <li class="">
                            <i class="fa fa-book text-muted w-5"></i>
                            {/* <FaGraduationCap className=" text-muted w-5"/> */}
                            Qualification : {freeLancers.course}
                          </li>
                          <li class="">
                            <i class="fa fa-flag text-muted w-5"></i>
                            {/* <FaGraduationCap className=" text-muted w-5"/> */}
                            Languages Known : {freeLancers.startedyear}
                          </li>
                          <li class="">
                            <i class="fa fa-th text-muted w-5"></i> Target
                            Locations : {freeLancers.coursetype}
                          </li>
                          <li class="">
                            <i class="fa fa-calendar-check-o text-muted w-5"></i>
                            {/* <FaCalendarWeek className=" text-muted w-5" /> */}
                            Portfolio : {freeLancers.passedyear}
                          </li>
                          <li class="">
                            <i class="fa fa-percent text-muted w-5"></i> Blogs /
                            Reels :{freeLancers.cgpa}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentTab === 4 && (
                <div class="card">
                  <div class="card-body">
                    <h4 class="mb-4">
                      Types of Marketing Service needed / provided
                    </h4>
                    <div class="mb-4">
                      <p>{freeLancers.process || "-- Not Disclosed --"}</p>
                    </div>
                    <hr />
                    <h4 class="mb-4">Work Approach - Collaboration</h4>
                    <div class="mb-4">
                      <p>{freeLancers.collabration || "-- Not Disclosed --"}</p>
                    </div>
                    <hr />
                    <h4 class="mb-4">Work Approach - Target Timeline</h4>
                    <div class="mb-4">
                      <p>
                        {freeLancers.timemanagement || "-- Not Disclosed --"}
                      </p>
                    </div>
                    <hr />
                    <h4 class="mb-4">Core Values / Philosophy</h4>
                    <div class="mb-4">
                      <p>{freeLancers.philosophy || "-- Not Disclosed --"}</p>
                    </div>
                    <hr />
                    <h4 class="mb-4">Specifications</h4>
                    <div class="row">
                      <div class="col-xl-6 col-md-12">
                        <ul class="list-unstyled widget-spec mb-0">
                          <li class="">
                            <i class="fa fa-code-fork text-muted w-5"></i>
                            Startup / Fresher : {freeLancers.employmentstatus}
                          </li>
                          <li class="">
                            <i class="fa fa-bank text-muted w-5"></i>
                            Nature of work : {freeLancers.companyname}
                          </li>

                          <li class="">
                            <i class="fa fa-calendar-o text-muted w-5"></i>
                            {/* <FaRegCalendar className=" text-muted w-5" /> */}
                            Years of Exp : {freeLancers.totalexperience}
                          </li>
                          <li class="">
                            <i class="fa fa-briefcase text-muted w-5"></i>
                            {/* <FaClock className=" text-muted w-5"/> */}
                            Specialization : {freeLancers.jobtitle}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentTab === 5 && photos.length > 0 && (
                <div className="card">
                  <div className="card-body text-center">
                    <img
                      style={{ height: "300px", width: "auto" }}
                      src={baseurl + photos[0].imageurl}
                      alt="Single Gallery Image"
                    />
                  </div>
                </div>
              )}


              {currentTab === 6 && (
                <div class="card">
                  <div class="card-body">
                    <h4 class="mb-4">Specialisation / Expertise</h4>
                    <div class="mb-4">
                      {freeLancers.skills ? (
                        <ul className="nav items-blog-tab-menu">
                          {freeLancers.skills.split(",").map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      ) : (
                        <p>-- Not Disclosed --</p>
                      )}
                    </div>
                    <hr />
                    <h4 class="mb-4">Tools Used</h4>
                    <div class="mb-4">
                      {freeLancers.tools ? (
                        <ul className="nav items-blog-tab-menu">
                          {freeLancers.tools.split(",").map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      ) : (
                        <p>-- Not Disclosed --</p>
                      )}
                    </div>
                    <hr />
                    <h4 class="mb-4">Additional Skills</h4>
                    <div class="mb-4">
                      {freeLancers.additionalskills ? (
                        <ul className="nav items-blog-tab-menu">
                          {freeLancers.additionalskills
                            .split(",")
                            .map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ul>
                      ) : (
                        <p>-- Not Disclosed --</p>
                      )}
                    </div>
                    <hr />
                    <h4 class="mb-4">Product / Service</h4>
                    <div class="mb-4">
                      {freeLancers.servicesoffered ? (
                        <ul className="nav items-blog-tab-menu">
                          {freeLancers.servicesoffered
                            .split(",")
                            .map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ul>
                      ) : (
                        <p>-- Not Disclosed --</p>
                      )}
                    </div>
                    <hr />
                    <h4 class="mb-4">Industries Served</h4>
                    <div class="mb-4">
                      {freeLancers.industriesserved ? (
                        <ul className="nav items-blog-tab-menu">
                          {freeLancers.industriesserved
                            .split(",")
                            .map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ul>
                      ) : (
                        <p>-- Not Disclosed --</p>
                      )}
                    </div>
                    <h4 class="mb-4">Service Areas</h4>
                    <div class="mb-4">
                      {freeLancers.servicearea ? (
                        <ul className="nav items-blog-tab-menu">
                          {freeLancers.servicearea
                            .split(",")
                            .map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ul>
                      ) : (
                        <p>-- Not Disclosed --</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {currentTab === 2 && (
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">Rating And Reviews</h3>
                  </div>
                  <div class="card-body p-0">
                    {comments.length <= 0 && (
                      <div
                        className="row  justify-content-center align-items-center text-center"
                        style={{ minHeight: 300 }}
                      >
                        <div className="col-lg-12">
                          <img
                            style={{ maxWidth: 100, marginBottom: 20 }}
                            src={require("../Assets/Images/cart.png")}
                          />
                          <h4>Be the first one to rate this.</h4>
                        </div>
                      </div>
                    )}
                    {comments.map((item) => {
                      return (
                        <div class="media p-5 border-top mt-0">
                          <div class="d-flex me-3">
                            <a href="#" onClick={(e) => e.preventDefault()}>
                              <ImageWithFallback
                                class="media-object brround"
                                src={baseurl + item.profilepic}
                                alt="User Avatar"
                              />
                            </a>
                          </div>
                          <div class="media-body">
                            <h5 class="mt-0 mb-1 font-weight-semibold">
                              {item.fullname}
                              <span class="fs-14 ms-2">
                                {item.rating} <FaStar className="text-yellow" />
                              </span>
                            </h5>
                            <small class="text-muted">
                              <span>
                                <FaCalendar /> &nbsp;&nbsp;
                                {item.date}
                              </span>
                              <span>
                                <FaMapMarker className="ms-3" /> &nbsp;&nbsp;
                                {item.city}
                              </span>
                            </small>
                            <p class="font-13  mb-2 mt-2">{item.message}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            {
              window.innerWidth <= 720 && <div className="col-xl-4 col-lg-4 col-md-12">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">Leave a Comment</h3>
                  </div>
                  <div class="card-body product-filter-desc">
                    <div class="product-tags clearfix">
                      <form
                        class="form"
                        name="contactForm"
                        onSubmit={(e) => {
                          e.preventDefault();
                          AddComments();
                        }}
                      >
                        <p>
                          Your email address will not be published. Required
                          fields are marked. <span class="text-danger">*</span>
                        </p>
                        <div class="form-group">
                          <label class="text-start" htmlFor="msg">
                            Rating :<span style={{ color: "red" }}>*</span>
                          </label>
                          <Rating
                            style={{ marginLeft: "10px" }}
                            initialValue={rating}
                            onClick={(number) => setRating(number)}
                          />
                          <label
                            class="text-start mt-5"
                            htmlFor="msg"
                            style={{ width: "100%" }}
                          >
                            Comment :<span style={{ color: "red" }}></span>
                            <small style={{ float: "right", marginLeft: "auto" }}>
                              {comment?.length || 0} / 500
                            </small>
                          </label>
                          <textarea
                            id="msg"
                            style={{ minHeight: 100, margin: 0 }}
                            name="comments"
                            class="form-control"
                            onChange={(e) => {
                              if (e.target.value.length <= 500)
                                setComment(e.target.value);
                            }}
                            value={comment}
                            placeholder="Type Message"
                          ></textarea>
                        </div>
                        <button class="btn btn-primary" type="submit">
                          Post Comment
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">Shares</h3>
                  </div>
                  <div class="card-body product-filter-desc">
                    <div class="product-filter-icons text-center">
                      <WhatsappShareButton
                        className=" apss-single-icon"
                        url={window.location.href}
                      >
                        <WhatsappIcon size={32} className="facebook-bg" />
                      </WhatsappShareButton>
                      <FacebookShareButton
                        className=" apss-single-icon"
                        url={window.location.href}
                      >
                        <FacebookIcon size={32} className="facebook-bg" />
                      </FacebookShareButton>
                      <TwitterShareButton
                        className=" apss-single-icon"
                        url={window.location.href}
                      >
                        <TwitterIcon size={32} className="apss-icon-block" />
                      </TwitterShareButton>
                      <PinterestShareButton
                        className=" apss-single-icon"
                        url={window.location.href}
                        media={window.location.href}
                      >
                        <PinterestIcon size={32} className="apss-icon-block" />
                      </PinterestShareButton>
                      <LinkedinShareButton
                        className=" apss-single-icon"
                        url={window.location.href}
                      >
                        <LinkedinIcon size={32} className="apss-icon-block" />
                      </LinkedinShareButton>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    </>
  );
}

export default IndividualDetail;
